import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { SearchTermService } from '../services/search-term.service';
import { User } from '../models/user';
import { UserService } from '../services/user.service';
import { Role } from '../models/role';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, tap } from 'rxjs/operators';
import { Paginator } from '../models/paginator';
import { LocationConfig, formatUtcIsoStringToLocal, getGatewayName } from "../models/locationconfig";

@Component({
  selector: 'app-list-merchants',
  templateUrl: './list-merchants.component.html',
  styleUrls: ['./list-merchants.component.sass'],
  standalone: false
})
export class ListMerchantsComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['mid', 'name', 'gatewayName', 'status', 'lastModifiedDateUtc'];
  dataSource = new MatTableDataSource<LocationConfig>();
  user: User;
  isLoading = false;
  paginator = new Paginator();
  formatUtcIsoStringToLocal = formatUtcIsoStringToLocal

  @ViewChild('search') input: ElementRef<HTMLInputElement>;

  constructor(
    private router: Router,
    private searchTermService: SearchTermService,
    private userService: UserService
  ) {
    this.userService.getUserRole().then((user) => {
      this.user = user;
    });
  }

  ngOnInit(): void {
    this.applyFilter(this.searchTermService.getTerm());
  }

  ngAfterViewInit() {
    // adding deboucing time for search input to avoid unnecessary requests while typing
    fromEvent(this.input.nativeElement,'keyup')
    .pipe(
      filter(Boolean),
      debounceTime(400),
      distinctUntilChanged(),
      tap((text) => {
        this.applyFilter(this.input.nativeElement.value as string);
      })
    )
    .subscribe();

    this.dataSource.data = [];
    this.isLoading = false;
    this.input.nativeElement.value = this.searchTermService.getTerm();
  }

  load() {
    this.isLoading = true;

    this.searchTermService.search().subscribe({
      next: (data) => {
        this.dataSource.data = data.locationConfigs;
        this.isLoading = false;
      },
      error: () => this.isLoading = false,
    })
  }

  applyFilter(filterValue: string) {
    this.searchTermService.saveTerm(filterValue);
    this.load();
  }

  getGatewayName(location: LocationConfig): string {
    return getGatewayName(location.location);
  }

  isEnabled(value: string): boolean {
    switch (this.user?.Role) {
      case Role.Admin:
      case Role.Maintainer:
        return true;
      default:
        return false;
    }
  }
}
